import Vue from 'vue';
import store from '@/store/index';
import { getStyle } from 'element-ui/src/utils/dom';

Vue.directive('showtip', {
  inserted: function(el, binding, vnode) {
    el.addEventListener('mouseenter', function(e) {
      const defalutSilent = !!Vue.config.silent;
      Vue.config.silent = true; // 取消 Vue 所有的日志与警告
      vnode.componentInstance.disabled = true; // 禁用 el-tooltip
      const range = document.createRange(); // 新增 Range
      range.setStart(el, 0); // 设置 Range 起点
      range.setEnd(el, el.childNodes.length); // 设置 Range 终点
      const rangeWidth = Math.round(range.getBoundingClientRect().width); // 获取当前元素相对于 浏览器视窗（可见区域） 的位置信息
      // 获取当前 el-tooltip 的 x 轴 padding 值
      const padding = (parseInt(getStyle(el, 'paddingLeft'), 10) || 0) + (parseInt(getStyle(el, 'paddingRight'), 10) || 0);
      // 判断 Range 宽度 + 获取当前 el-tooltip 的 x 轴 padding 值 是否大于 el-tooltip 的 offsetWidth
      if (rangeWidth + padding > el.offsetWidth || el.scrollWidth > el.offsetWidth) {
        vnode.componentInstance.disabled = false; // 启用 el-tooltip
      }
      Vue.config.silent = defalutSilent; // 启用 Vue 所有的日志与警告
    });
  }
});

Vue.directive('resize', {
  bind(el, binding) {
    let width = '';
    let height = '';
    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value();
      }
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 300);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  }
});

Vue.directive('has', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      if (el.previousElementSibling && el.previousElementSibling.className.includes('el-divider')) {
        el.parentNode.removeChild(el.previousElementSibling);
      }
      if (el.parentNode && el.parentNode.className.includes('el-tabs__item')) {
        el.parentNode.parentNode.removeChild(el.parentNode);
      } else {
        el.parentNode.removeChild(el);
      }
    }
  }
});

Vue.prototype.$_has = function(value) {
  let btnPermisstions = store.state.base.roleIds;
  if (!Array.isArray(btnPermisstions)) {
    return false;
  }
  if (!value) {
    return true;
  }
  if (Array.isArray(value) && btnPermisstions.some(permission => value.includes(permission))) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utils/directives.js